import {clsx} from "clsx";
import {FCWithHTMLAttributes} from "../types/reactTypes";

/**
 * Represents a single tag or label in a list of tags or labels
 */
const Tag: FCWithHTMLAttributes = ({className = "", children, ...props}) => (
	<div
		className={clsx(
			"max-w-full overflow-hidden text-ellipsis whitespace-nowrap rounded-full bg-gray-200 px-3 py-0.5 text-gray-800",
			className
		)}
		{...props}
	>
		{children}
	</div>
);

export default Tag;
